import * as React from 'react';
import { Button } from '@cian/ui-kit';

import { TRequestCallbackOpener } from '../../types/requestCallback';
import { useCallbackButton } from './useCallbackButton';

interface ISecondaryCallbackButtonProps {
  placeType: TRequestCallbackOpener;
}

export function SecondaryCallbackButton({ placeType }: ISecondaryCallbackButtonProps) {
  const [isAvailable, handleClick] = useCallbackButton(placeType);

  if (!isAvailable) {
    return null;
  }

  return (
    <Button theme="fill_secondary" size={'M'} onClick={handleClick} fullWidth>
      Перезвоните мне
    </Button>
  );
}
